//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Components
import FooterItem from "./FooterItem"

//Config
import footerItems from "../../../config/footer-menu-items"

const Footer = () => {
  return (
    <footer>
      <div className={style.Container}>
        <div className={style.Wrapper}>
          {footerItems.map((item, index) => (
            <FooterItem key={item.key} {...item}></FooterItem>
          ))}
        </div>
      </div>
    </footer>
  )
}

export default Footer
